
// export function smartSplitWithBracket(input) {
//   const result = [];

//   // Normalize: ensure symbols like †, +, * get separated
//   const normalized = input
//     .replace(/-\*/g, '-|')     // Replace -* with a split marker
//     .replace(/([†+])/g, '|')   // Split on † or +
//     .replace(/([()])/g, '|$1|'); // Keep brackets isolated

//   const rawParts = normalized.split('|').map(part => part.trim()).filter(Boolean);

//   // Reconstruct: Merge bracketed codes and valid ICD codes
//   const merged = [];
//   for (let i = 0; i < rawParts.length; i++) {
//     const part = rawParts[i];
//     if (part.startsWith('(')) {
//       let bracket = part;
//       while (!bracket.endsWith(')') && i + 1 < rawParts.length) {
//         i++;
//         bracket += rawParts[i];
//       }
//       merged.push(bracket);
//     } else {
//       merged.push(part);
//     }
//   }

//   return merged;
// }

export function smartSplitWithBracket(input) {
  const result = [];
 
  // Normalize: ensure symbols like †, +, * get separated
  const normalized = input
    .replace(/-\*/g, '-|')     // Replace -* with a split marker
    .replace(/([†+])/g, '|')   // Split on † or +
    .replace(/([()])/g, '|$1|'); // Keep brackets isolated
 
  const rawParts = normalized.split('|').map(part => part.trim()).filter(Boolean);
 
  // Reconstruct: Merge bracketed codes and valid ICD codes
  const merged = [];
  for (let i = 0; i < rawParts.length; i++) {
    const part = rawParts[i];
    if (part.startsWith('(')) {
      let bracket = part;
      while (!bracket.endsWith(')') && i + 1 < rawParts.length) {
        i++;
        bracket += rawParts[i];
      }
      merged.push(bracket);
    } else {
      merged.push(part);
    }
  }
 
  // Remove parentheses from each part
  return merged.map(part => part.replace(/[()]/g, ''));
}

export function getPrimaryCode(codes) {
  if (!Array.isArray(codes) || codes.length === 0) return "";

  const clean = (code) =>
    code.replace(/[+*†]+$/, '').replace(/^\(|\)$/g, '').trim();

  // Filter out codes ending with - or -*
  const primaryCandidates = codes.filter(code =>
    !code.endsWith('-') && !code.endsWith('-*')
  );

  // Prioritize non-bracketed ICD codes
  for (let c of primaryCandidates) {
    if (!/^\(.*\)$/.test(c)) return clean(c);
  }

  // If only morphology or invalid codes, return best available
  return clean(primaryCandidates[0] || codes[0]);
}


export function prioritizeParts(parts) {
  const priorityOrder = ["-", "†", "*"];
  const prioritized = [];

  // Make a copy so we don't mutate the original
  const remaining = [...parts];

  // Go through priority symbols
  priorityOrder.forEach((symbol) => {
    const index = remaining.findIndex((p) => p.includes(symbol));
    if (index !== -1) {
      // Remove from remaining and push to prioritized
      prioritized.push(remaining.splice(index, 1)[0]);
    }
  });

  // Add any remaining codes at the end
  return [...prioritized, ...remaining];
}

